import { unsafePositiveInteger } from "@dbn/omnichannel-design-system-g4p";

export const messageTimeFormat = "DD/MM/YYYY - HH:mm";
export const threadPageSize = unsafePositiveInteger(10);
